var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 0.5H1.2C0.88174 0.5 0.576516 0.626428 0.351472 0.851472C0.126428 1.07652 0 1.38174 0 1.7V3.3C0 3.61826 0.126428 3.92348 0.351472 4.14853C0.576516 4.37357 0.88174 4.5 1.2 4.5H26.8C27.1183 4.5 27.4235 4.37357 27.6485 4.14853C27.8736 3.92348 28 3.61826 28 3.3V1.7C28 1.38174 27.8736 1.07652 27.6485 0.851472C27.4235 0.626428 27.1183 0.5 26.8 0.5ZM26.8 8.5H1.2C0.88174 8.5 0.576516 8.62643 0.351472 8.85147C0.126428 9.07652 0 9.38174 0 9.7V11.3C0 11.6183 0.126428 11.9235 0.351472 12.1485C0.576516 12.3736 0.88174 12.5 1.2 12.5H26.8C27.1183 12.5 27.4235 12.3736 27.6485 12.1485C27.8736 11.9235 28 11.6183 28 11.3V9.7C28 9.38174 27.8736 9.07652 27.6485 8.85147C27.4235 8.62643 27.1183 8.5 26.8 8.5ZM26.8 16.5H1.2C0.88174 16.5 0.576516 16.6264 0.351472 16.8515C0.126428 17.0765 0 17.3817 0 17.7V19.3C0 19.6183 0.126428 19.9235 0.351472 20.1485C0.576516 20.3736 0.88174 20.5 1.2 20.5H26.8C27.1183 20.5 27.4235 20.3736 27.6485 20.1485C27.8736 19.9235 28 19.6183 28 19.3V17.7C28 17.3817 27.8736 17.0765 27.6485 16.8515C27.4235 16.6264 27.1183 16.5 26.8 16.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMenu);
export default __webpack_public_path__ + "static/media/icone-menu.297e879d38cddfe64e17da3fc9543c1d.svg";
export { ForwardRef as ReactComponent };